import { matchPath, useLocation } from 'react-router-dom'

import { useNavigation as useFactorialNavigation } from 'modules/core/hooks/useNavigation'

const useIsPayrollOnboardingFlow = (): boolean => {
  const { pathname } = useLocation()
  const { navigation } = useFactorialNavigation()

  const payrollPatterns = [navigation.payrollBundle.fullPath()]

  const pathMatches = payrollPatterns.find((pattern) => matchPath(pattern, pathname))

  return !!pathMatches
}

export default useIsPayrollOnboardingFlow
